import React from "react";
import { Link, NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { LayoutGrid, Calendar, Users, MessageSquare, ImageIcon, Camera, LogOut, CalendarCheck, CalendarDays, Tag, Rss, Printer, FileSignature, Link2, Bell, Star, Gift, Megaphone } from "lucide-react";

const NAV = [
  { to: "/admin/site", icon: Camera, label: "Site & réservations" },
  { to: "/admin/dashboard", icon: LayoutGrid, label: "Tableau de bord" },
  { to: "/admin/reservations", icon: CalendarCheck, label: "Réservations" },
  { to: "/admin/waitlist", icon: Bell, label: "Liste d'attente" },
  { to: "/admin/cartes-cadeau", icon: Gift, label: "Cartes cadeau" },
  { to: "/admin/marketing", icon: Megaphone, label: "Marketing IG" },
  { to: "/admin/prospection", icon: Users, label: "Prospection studio", testId: "admin-nav-prospection" },
  { to: "/admin/boutique-pdf", icon: Gift, label: "Boutique PDF", testId: "admin-nav-pdf-shop" },
  { to: "/admin/devis", icon: FileSignature, label: "Devis mariages" },
  { to: "/admin/calendrier", icon: CalendarDays, label: "Calendrier" },
  { to: "/admin/liens-partage", icon: Link2, label: "Liens de partage" },
  { to: "/admin/services-images", icon: ImageIcon, label: "Images services" },
  { to: "/admin/temoignages", icon: Star, label: "Témoignages" },
  { to: "/admin/promo-codes", icon: Tag, label: "Codes promo" },
  { to: "/admin/calendar-sync", icon: Rss, label: "Sync Agenda" },
  { to: "/admin/kit-imprimes", icon: Printer, label: "Kit imprimés" },
  { to: "/admin/sessions", icon: Calendar, label: "Workshops" },
  { to: "/admin/participants", icon: Users, label: "Participants" },
  { to: "/admin/messages", icon: MessageSquare, label: "Messages" },
  { to: "/admin/portfolio", icon: ImageIcon, label: "Portfolio" },
  { to: "/admin/studio-refs", icon: Camera, label: "Studio Refs" },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const token = localStorage.getItem("se_admin_token");
  if (!token) return <Navigate to="/admin/login" replace/>;

  const logout = () => {
    localStorage.removeItem("se_admin_token");
    localStorage.removeItem("se_admin_email");
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen section-dark grid grid-cols-1 md:grid-cols-[260px_minmax(0,1fr)]">
      <aside className="border-r border-white/10 p-6 md:p-8 flex flex-col" data-testid="admin-sidebar">
        <Link to="/" className="flex items-center gap-3">
          <img src="/logo-white.png" alt="Studio Euclides" className="h-10 w-auto" width="40" height="40" />
          <span className="font-serif text-xl">
            Studio <span className="italic-accent">Euclides</span>
          </span>
        </Link>
        <div className="eyebrow text-text-cream/40 mt-1">Admin</div>
        <nav className="mt-10 flex flex-col gap-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} data-testid={n.testId || `admin-nav-${n.label}`} className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-3 text-sm font-light transition ${isActive ? "bg-accent-deep/15 text-accent-light border-l-2 border-accent-deep" : "text-text-cream/60 hover:text-text-cream"}`
            }>
              <n.icon size={16} strokeWidth={1.5}/> {n.label}
            </NavLink>
          ))}
        </nav>
        <button onClick={logout} className="mt-auto flex items-center gap-2 text-text-cream/40 hover:text-accent-light text-sm" data-testid="admin-logout">
          <LogOut size={14}/> Déconnexion
        </button>
      </aside>
      <main className="min-w-0 p-4 sm:p-6 lg:p-12">
        <Outlet/>
      </main>
    </div>
  );
}
